import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import FaqMain from './FaqMain';
import Footer from '../../components/Footer';

const Faq = () => {
  return (
    <>
      <HeaderSeven />

      <FaqMain />

      <Footer />
    </>
  );
};

export default Faq;
